let activeCollection = 'all-meals';
const filterTrigger = document.getElementById('filter-modal-toggle');
const filterModal = document.getElementById('filter-modal');
const filterSubmit = document.getElementById('filter-submit');
const filterReset = document.getElementById('filter-reset');
const collectionButtons = document.querySelectorAll('.collection-buttons a');

// Toggle the filter dropdown
filterTrigger.addEventListener('click', (e) => {
  e.preventDefault();
  filterModal.classList.toggle('tw-hidden');
});

// Prevent form submit on modal click
filterModal.addEventListener('click', (e) => {
  e.stopPropagation();
});

// Grab products when filter form submitted
filterSubmit.addEventListener('click', (e) => {
  e.preventDefault();

  const url = getFilterUrl();
  const checkedInputs = document.querySelectorAll('#filter-modal input:checked');

  if(checkedInputs.length === 0 && activeCollection === 'all-meals') {
    resetLayout();
  } else {
    const defaultSections = document.querySelectorAll('.all-products-section');
    defaultSections.forEach((section, index) => {
      section.classList.add('hidden');
    });
    document.querySelector('#grid-loader').classList.remove('hidden');
    document.querySelector('#shopify-section-main-grid').classList.add('hidden');
    productFilterSearch(url, 'main-grid');
  }

  filterModal.classList.toggle('tw-hidden');
  
});

// Grab products when filters cleared
filterReset.addEventListener('click', (e) => {
  e.preventDefault();

  const inputs = document.querySelectorAll('#filter-modal input');

  inputs.forEach((input) => {
    input.checked = false;
  });

  const url = getFilterUrl();

  if(activeCollection === 'all-meals') {
    resetLayout();
  } else {
    productFilterSearch(url, 'main-grid');
  }
  
});

// Grab new products
const productFilterSearch = (url, sectionId, skip = false, title = false) => {
  fetch(url)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const productGrid = doc.querySelector('.product-grid');
      let newItems = null;

      // Reveal initial products which are hidden on mobile
      const hiddenProducts = document.querySelectorAll('.grid__item_desk');

      hiddenProducts.forEach((product, index) => {
        product.classList.remove('grid__item_desk');
      });

      if(productGrid) {
        if(skip) {
          const listItems = doc.querySelectorAll('.product-grid li:nth-child(n+9)');
          let html = '';
          listItems.forEach((listItem, index) => {
            html += listItem.outerHTML;
          });

          newItems = html;
        } else {
          newItems = doc.querySelector('.product-grid').innerHTML;
        }
      }

      const sliderSelector = 'Slider-' + sectionId;
      const slider = document.getElementById(sliderSelector);
      const buttonSelector = '#shopify-section-' + sectionId + ' .collection-view-more';
      const buttons = document.querySelectorAll(buttonSelector);
      const paginationElement = doc.querySelector('.pagination__item--current');
      let page = 1;
      let nextPage, totalPagesElement, totalPages = false;
      if(paginationElement) {
        page = doc.querySelector('.pagination__item--current').innerHTML;
        nextPage = parseInt(page) + 1;
        totalPagesElement = doc.querySelector('#pagination-total').innerHTML;
        totalPages = parseInt(totalPagesElement)
      }

      // Replace grid content if a new collection
      if(sectionId == 'main-grid' && page == 1) {
        slider.innerHTML = newItems;
      } else {
        slider.innerHTML += newItems;
      }

      // Reveal the main product grid if we're filtering down to collection
      if(sectionId == 'main-grid') {
        document.querySelector('#shopify-section-main-grid').classList.remove('hidden');
      }

      if(title) {
        document.querySelector('#shopify-section-main-grid header h2').textContent = title;
      }
      
      // Check if more products in collection
      if(paginationElement && nextPage && nextPage <= totalPages) {
        if(url.includes('page=1')) {
          // this is a 'view more' button with page parameter already present
          url = url.replace('page=1', 'page=' + nextPage);
        } else {
          url += '&page=' + nextPage;
        }

        buttons.forEach((button) => {
          button.setAttribute('data-url', url);
          button.parentNode.classList.remove('hidden');
        });

      } else {
        buttons.forEach((button) => {
          button.parentNode.classList.add('hidden');
        });
      }

      // Remove loading graphic
      const loadingElement = document.querySelector('.loading-animation');
      if(loadingElement) {
        loadingElement.parentNode.removeChild(loadingElement);
      }
      
      document.querySelector('#grid-loader').classList.add('hidden');

      var api = new Yotpo.API(yotpo);
      api.refreshWidgets();
      
    });
}

// Fire off ajax request when collection button clicked
collectionButtons.forEach((button, index) => {
  button.addEventListener('click', (e) => {
    e.preventDefault();

    collectionButtons.forEach((button, index) => {
      button.parentNode.classList.remove('active');
    });

    e.target.parentNode.classList.add('active');

    activeCollection = e.target.dataset.collection;

    dataUrl = e.target.dataset.url;

    const title = e.target.textContent;

    // Show the default layout if 'All Meals' is clicked
    if(dataUrl == 'reset') {
      resetLayout();
    } else {
      const defaultSections = document.querySelectorAll('.all-products-section');
      defaultSections.forEach((section, index) => {
        section.classList.add('hidden');
      });
      document.querySelector('#grid-loader').classList.remove('hidden');
      document.querySelector('#shopify-section-main-grid').classList.add('hidden');
      const url = getFilterUrl();
      productFilterSearch(url, 'main-grid', false, title);
    }
  });
});

// Build the request url
function getFilterUrl() {
  let url = `/collections/${activeCollection}`;
  const checkedInputs = document.querySelectorAll('#filter-modal input:checked');

  checkedInputs.forEach((element, index) => {
    if(index === 0) {
      url += `/${element.value}`;
    } else {
      url += `+${element.value}`
    }
  });

  url += '?section_id=main-collection-product-grid';

  return url;
}

// Reset page to the default layout
function resetLayout() {
  document.querySelector('#shopify-section-main-grid').classList.add('hidden');
  const defaultSections = document.querySelectorAll('.all-products-section');
  defaultSections.forEach((section, index) => {
    section.classList.remove('hidden');
  });
}

// Listen for 'view more' clicks and fire off ajax request
const viewMoreButtons = document.querySelectorAll('.collection-view-more');

viewMoreButtons.forEach((button, index) => {
  button.addEventListener('click', (e) => {
    e.preventDefault();
    const parent = e.target.parentNode;
    parent.classList.add('hidden');
    const loader = document.createElement('div');
    loader.classList.add('loading-animation');
    console.log(loader);
    parent.parentNode.insertBefore(loader, parent);

    const sectionId = e.target.dataset.section;
    const url = e.target.dataset.url;

    let skip = false;

    // Check if is a default layout 'view more' button and skip the first 8 items returned if so
    if(url.includes('page=1')) {
      skip = true;
    }

    productFilterSearch(url, sectionId, skip, false);
  });
});